// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__COTtD","content":"LoadingAlert_content__3QLN1"};